import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { FormStateService } from './form-state.service';

// TODO deprecate this interceptor, make sure forms are well developed so we don't need this hack
@Injectable()
export class PreventDoubleSubmitInterceptor implements HttpInterceptor {
  private formStateService = inject(FormStateService);

  private pendingRequests = new Set<string>();

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const submittingRequestArray = ['POST', 'PUT', 'DELETE', 'PATCH'];
    const exceptionsArray = ['satellite/images', 'satellite/statistics'];

    const requestKey = this.getRequestKey(req);

    if (exceptionsArray.find((s) => req.url.includes(s))) {
      return next.handle(req);
    }

    if (
      this.pendingRequests.has(requestKey) &&
      submittingRequestArray.includes(req.method)
    ) {
      console.warn(
        `Prevented double submit for request: ${req.method} ${req.urlWithParams}`,
      );
      return new Observable<HttpEvent<any>>();
    } else {
      this.pendingRequests.add(requestKey);

      if (submittingRequestArray.includes(req.method)) {
        this.formStateService.notifyFormSubmit(true);
      }

      return next.handle(req).pipe(
        finalize(() => {
          this.pendingRequests.delete(requestKey);
          if (submittingRequestArray.includes(req.method)) {
            this.formStateService.notifyFormSubmit(false);
          }
        }),
      );
    }
  }

  private hashBody(body: any): string {
    return JSON.stringify(body);
  }

  private getRequestKey(req: HttpRequest<any>): string {
    return `${req.method} ${req.urlWithParams} ${this.hashBody(req.body)}`;
  }
}
